import { useEffect } from 'react';
import PropTypes from 'prop-types';

export function useInjectTalkDesk({ isUserCubohOnly, isAuthenticated }) {
  useEffect(() => {
    // dont inject script if user is cuboh only (HUB) or not logged in yet
    if (isUserCubohOnly || !isAuthenticated) {
      return undefined;
    }

    const existingScript = document.getElementById('tdwebchatscript');
    if (existingScript) return undefined;

    // Create a container specifically for the widget
    const widgetContainer = document.createElement('div');
    widgetContainer.id = 'talkdesk-widget-container';
    widgetContainer.style.cssText = 'z-index: calc(var(--mantine-z-index-overlay) + 1)';
    document.body.appendChild(widgetContainer);

    const script = document.createElement('script');
    script.src = 'https://talkdeskchatsdk.talkdeskapp.com/v2/talkdeskchatsdk.js';
    script.type = 'text/javascript';
    script.id = 'tdwebchatscript';
    script.async = true;

    script.onload = () => {
      const divContainer = document.createElement('div');
      divContainer.id = 'tdWebchat';
      widgetContainer.appendChild(divContainer);

      window.webchat = window.TalkdeskChatSDK?.('tdWebchat', {
        touchpointId: import.meta.env.VITE_TALKDESK_TOUCHPOINT_ID,
        accountId: '',
        region: 'td-us-1',
      });

      window.webchat?.init({
        enableValidation: true,
        enableEmoji: true,
        enableUserInput: true,
        enableAttachments: true,
        styles: {
          customFieldPhoneDescription:
            'Include the + sign and country code, avoid spaces or dashes. For example: +18887072469, instead of 1 888-707-2469.',
        },
      });
    };

    document.body.appendChild(script);

    return () => {
      // Clean up webchat instance
      if (window.webchat) {
        window.webchat.destroy();
        window.webchat = null;
      }

      // Clean up widget container
      const container = document.getElementById('talkdesk-widget-container');
      const containerParent = container?.parentNode;
      if (containerParent) {
        containerParent.removeChild(container);
      }

      const cleanupScript = document.getElementById('tdwebchatscript');
      const scriptParent = cleanupScript?.parentNode;
      if (scriptParent) {
        scriptParent.removeChild(cleanupScript);
      }
    };
  }, [isUserCubohOnly, isAuthenticated]);
}

useInjectTalkDesk.propTypes = {
  isUserCubohOnly: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};
